// extracted by mini-css-extract-plugin
module.exports = {"avatar":"_1XkRJwyO _19nl5dYQ","checkmark":"_2LTRkggr GUTMtdJ8 Cu_bt0Ib"};